import React, { useState, useEffect } from 'react';
import { X, Cookie, Shield } from 'lucide-react';
import { Button } from './ui/button';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('doozum_cookie_consent');
    if (!consent) {
      // Show banner after 1 second
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = {
      cookies: true,
      analytics: true,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('doozum_cookie_consent', JSON.stringify(consent));
    setShowBanner(false);
  };

  const handleAcceptEssential = () => {
    const consent = {
      cookies: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('doozum_cookie_consent', JSON.stringify(consent));
    setShowBanner(false);
  };

  const handleReject = () => {
    const consent = {
      cookies: false,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('doozum_cookie_consent', JSON.stringify(consent));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-4 border-[#1C3E53] shadow-2xl animate-slide-up">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-3">
              <Cookie className="h-6 w-6 text-[#1C3E53]" />
              <h3 className="text-lg font-bold text-gray-900">
                🍪 Respect de votre vie privée
              </h3>
            </div>
            
            <p className="text-sm text-gray-700 mb-4">
              Nous utilisons des cookies pour améliorer votre expérience, analyser notre trafic et personnaliser le contenu. 
              Vous pouvez accepter tous les cookies ou choisir vos préférences.
            </p>

            {showDetails && (
              <div className="mb-4 p-4 bg-gray-50 rounded-lg text-sm space-y-2">
                <div>
                  <strong>🔒 Cookies essentiels :</strong> Nécessaires au fonctionnement du site (authentification, sessions). <span className="text-green-600 font-semibold">Toujours activés</span>
                </div>
                <div>
                  <strong>📊 Cookies analytiques :</strong> Nous aident à comprendre comment vous utilisez Doozum pour améliorer nos services.
                </div>
                <div>
                  <strong>📢 Cookies marketing :</strong> Actuellement <span className="text-red-600 font-semibold">non utilisés</span> sur Doozum.
                </div>
              </div>
            )}

            <div className="flex flex-wrap items-center gap-3">
              <Button
                onClick={handleAcceptAll}
                className="bg-[#1C3E53] hover:bg-[#2A5470] text-white font-semibold"
              >
                ✅ Accepter tous les cookies
              </Button>
              
              <Button
                onClick={handleAcceptEssential}
                variant="outline"
                className="border-[#1C3E53] text-[#1C3E53] hover:bg-[#1C3E53]/10 font-semibold"
              >
                🔒 Cookies essentiels uniquement
              </Button>
              
              <Button
                onClick={handleReject}
                variant="ghost"
                className="text-gray-600 hover:text-gray-900"
              >
                ❌ Tout refuser
              </Button>

              <button
                onClick={() => setShowDetails(!showDetails)}
                className="text-sm text-[#1C3E53] underline hover:no-underline ml-auto"
              >
                {showDetails ? 'Masquer les détails' : 'En savoir plus'}
              </button>
            </div>

            <div className="mt-3 flex items-center space-x-4 text-xs text-gray-500">
              <a href="/privacy" className="hover:text-[#1C3E53] underline flex items-center space-x-1">
                <Shield className="h-3 w-3" />
                <span>Politique de confidentialité</span>
              </a>
              <span>•</span>
              <span>Conformité RGPD</span>
            </div>
          </div>

          <button
            onClick={() => setShowBanner(false)}
            className="text-gray-400 hover:text-gray-600 ml-4"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
